import { WebScrapingService } from 'api-new/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';

type EsaInfoParams = {
  regNo?: string;
  userId?: number;
  isForced?: boolean;
};

export const useEsaInfoMutation = () =>
  useMutation(
    (input: EsaInfoParams) =>
      WebScrapingService.getWebScrapingGetEsaInfoForced(input.regNo, input.userId, input.isForced),
    {
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
      }
    }
  );
